import {
  faBoxOpen,
  faCalendar, faCalendarMinus, faCar, faCode,
  faDolly, faFileExcel, faPaintRoller,
  faPeopleGroup,
  faPerson,
  faReceipt,
  faClock,
  faSatellite,
  IconDefinition, faBriefcase
} from "@fortawesome/free-solid-svg-icons";
import config from "./config";

export const navigation: {link: string, icon: IconDefinition, text: string}[] = [
  {
    link: '/',
    text: 'Planning',
    icon: faCalendar,
  },
  {
    link: '/bestellingen',
    text: 'Bestellingen',
    icon: faDolly,
  },
  {
    link: '/workorders',
    text: 'Werkbonnen',
    icon: faReceipt,
  },
  {
    link: '/werkbezoeken',
    text: 'Werkbezoeken',
    icon: faBriefcase,
  },
  {
    link: '/tracking',
    text: 'Live Locatie',
    icon: faSatellite,
  },
  {
    link: '/personeel',
    text: 'Personeel',
    icon: faPerson,
  },
  {
    link: '/teams',
    text: 'Teams',
    icon: faPeopleGroup,
  },
  {
    link: '/holidays',
    text: 'Vrije dagen',
    icon: faCalendarMinus,
  },
  {
    link: '/reports',
    text: 'Rapportage',
    icon: faFileExcel,
  },
  {
    link: '/leveranciers',
    text: 'Leveranciers',
    icon: faBoxOpen,
  },
  {
    link: '/uren',
    text: 'Uren',
    icon: faClock,
  },
  {
    link: '/kleuren',
    text: 'Kleuren',
    icon: faPaintRoller,
  },
  ...(config.devMode ? [
    {
      link: '/instellingen',
      text: 'DevSettings',
      icon: faCode,
    },
  ] : []),
]